/**
 * @generated SignedSource<<9578f84bd0ca9a0c5416ed46ecb7cc5b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TaskTypingAutomationHistoryPaginator_task$data = {
  readonly id: string;
  readonly typingAutomationHistories: {
    readonly edges: ReadonlyArray<{
      readonly cursor: string;
      readonly node: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"TypingAutomationHistoryDialog_typingAutomationHistory" | "TypingAutomationHistoryTimelineItem_typingAutomationHistory">;
      };
    }>;
    readonly pageInfo: {
      readonly endCursor: string | null;
      readonly hasNextPage: boolean;
    };
    readonly totalCount: number | null;
  };
  readonly " $fragmentType": "TaskTypingAutomationHistoryPaginator_task";
};
export type TaskTypingAutomationHistoryPaginator_task$key = {
  readonly " $data"?: TaskTypingAutomationHistoryPaginator_task$data;
  readonly " $fragmentSpreads": FragmentRefs<"TaskTypingAutomationHistoryPaginator_task">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "typingAutomationHistories"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "order"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./TaskTypingAutomationHistoryPaginatorRefreshQuery.graphql'),
      "identifierField": "id"
    }
  },
  "name": "TaskTypingAutomationHistoryPaginator_task",
  "selections": [
    {
      "alias": "typingAutomationHistories",
      "args": [
        {
          "kind": "Variable",
          "name": "order",
          "variableName": "order"
        }
      ],
      "concreteType": "TypingAutomationHistoryConnection",
      "kind": "LinkedField",
      "name": "__TaskTypingAutomationHistoryPaginator_task_typingAutomationHistories_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TypingAutomationHistoryEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "TypingAutomationHistory",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "TypingAutomationHistoryTimelineItem_typingAutomationHistory"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "TypingAutomationHistoryDialog_typingAutomationHistory"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v1/*: any*/)
  ],
  "type": "Task",
  "abstractKey": null
};
})();

(node as any).hash = "dd2a0ddd1ada1f8fabaf4d7e59edd158";

export default node;
